var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4759 9.53985C15.6999 9.41004 15.9867 9.48629 16.1165 9.71029L17.9056 12.7962C18.0354 13.0202 17.9592 13.307 17.7352 13.4369C17.5112 13.5667 17.2244 13.4904 17.0945 13.2664L15.3055 10.1805C15.1757 9.95654 15.2519 9.66973 15.4759 9.53985Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9656 11.2024C12.2206 11.1575 12.4637 11.3277 12.5086 11.5827L13.0633 14.7311C13.1082 14.9861 12.9379 15.2292 12.683 15.2741C12.4281 15.319 12.1849 15.1487 12.14 14.8938L11.5853 11.7454C11.5404 11.4904 11.7107 11.2473 11.9656 11.2024Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02653 11.1947C8.28147 11.2395 8.45184 11.4825 8.40703 11.7375L7.85234 14.8937C7.80753 15.1487 7.56453 15.319 7.30953 15.2742C7.05459 15.2294 6.88422 14.9864 6.92903 14.7314L7.48372 11.5752C7.52853 11.3202 7.77153 11.1498 8.02653 11.1947Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51554 9.53924C4.73979 9.66862 4.81672 9.95524 4.68737 10.1795L2.89831 13.2811C2.76895 13.5053 2.4823 13.5822 2.25805 13.4529C2.0338 13.3236 1.95687 13.0369 2.08623 12.8126L3.87529 9.71105C4.00464 9.4868 4.29129 9.40987 4.51554 9.53924Z",
    fill: "#BBBBBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20548 7.83067C2.40688 7.66798 2.70201 7.69942 2.86468 7.9008C4.1254 9.46167 6.41055 11.4063 10 11.4063C13.5895 11.4063 15.8746 9.46167 17.1354 7.9008C17.298 7.69942 17.5932 7.66798 17.7945 7.83067C17.9959 7.99336 18.0274 8.28848 17.8647 8.48986C16.5004 10.179 13.973 12.3438 10 12.3438C6.02697 12.3438 3.49964 10.179 2.13536 8.48986C1.97269 8.28848 2.00409 7.99336 2.20548 7.83067Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.fa23f2ce4e193786c6b0679f8ee350b3.svg";
export { ForwardRef as ReactComponent };